import type { GrowthPackDefinition } from '../../../domain/industry/types';
import { buildPack, PACK_CONTENT } from './packBuilder';

const growthPacks: GrowthPackDefinition[] = [
  {
    id: 'health_growth_starter',
    industryId: 'healthtech',
    tier: 1,
    name: 'Clinical Foundations',
    description: 'EHR and telehealth with HIPAA training missions.',
    unlocks: {
      productIds: ['health_ehr', 'health_telehealth'],
      missionIds: ['health_mission_hipaa'],
    },
  },
  {
    id: 'health_growth_analytics',
    industryId: 'healthtech',
    tier: 2,
    name: 'Analytics & Risk',
    description: 'Unlock analytics after HIPAA training complete.',
    unlockConditions: { completedMissionIds: ['health_mission_hipaa'], minCompliance: 60 },
    unlocks: {
      productIds: ['health_analytics'],
      missionIds: ['health_mission_risk'],
    },
  },
  {
    id: 'health_growth_advanced',
    industryId: 'healthtech',
    tier: 3,
    name: 'Advanced Care',
    description: 'Imaging AI after risk assessment mission.',
    unlockConditions: { completedMissionIds: ['health_mission_risk'] },
    unlocks: {
      productIds: ['health_imaging'],
      missionIds: ['health_mission_breach'],
    },
  },
];

export const healthtechPack = buildPack({
  id: 'healthtech',
  ...PACK_CONTENT.healthtech,
  growthPacks,
  expansionPacks: [
    {
      id: 'health_exp_clinical_trials',
      industryId: 'healthtech',
      name: 'Clinical Trials Module',
      version: '1.0.0',
      description: 'FDA Part 11 focused expansion for research workflows.',
      requiresGrowthTierId: 'health_growth_analytics',
      adds: { frameworkIds: ['fda_21cfr11'] },
    },
  ],
});